module.exports = __webpack_public_path__ + "img/logo.09c41e33.svg";